(() => {
  'use strict';
  const targetPaths = [
    '/products/callaway-alumni-vintage-charger-for-life-t-shirt',
    '/products/murrah-mustangs-alumni-varsity-mascot-t-shirt',
    '/products/50-custom-screen-printed-t-shirts-1-color-print'
  ];
  if (!targetPaths.includes(location.pathname)) return;
  const safe = value => typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9 _.-]{0,99}$/.test(value) ? value : '';
  const campaignProperties = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (!privacy || privacy.analyticsProcessingAllowed() !== true || privacy.marketingAllowed() !== true) return {};
    } catch (_) { return {}; }
    const query = new URLSearchParams(location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_id'];
    const labels = ['_Campaign source', '_Campaign medium', '_Campaign', '_Campaign content', '_Campaign ID'];
    const result = {};
    const source = safe(query.get('utm_source'));
    if (!source) return result;
    keys.forEach((key, index) => {
      const value = safe(key === 'utm_id' && !query.has(key) ? query.get('mc_cid') : query.get(key));
      if (value) result[labels[index]] = value;
    });
    result['_Landing path'] = location.pathname;
    try {
      const referrer = new URL(document.referrer);
      if (/^https?:$/.test(referrer.protocol) && /^[a-zA-Z0-9.-]{1,253}$/.test(referrer.hostname)) result['_Referrer hostname'] = referrer.hostname;
    } catch (_) {}
    return result;
  };
  const applyCampaign = () => {
    const values = campaignProperties();
    document.querySelectorAll('#MainContent form[action*="/cart/add"]').forEach(form => {
      const component = form.closest('product-form-component');
      if (component && new URL(component.dataset.productUrl, location.origin).pathname !== location.pathname) return;
      const present = new Map();
      form.querySelectorAll('[data-lfg-product-attribution]').forEach(input => {
        const key = input.dataset.lfgProductAttribution;
        if (!(key in values) || present.has(key)) input.remove();
        else {
          if (input.value !== values[key]) input.value = values[key];
          present.set(key, input);
        }
      });
      Object.entries(values).forEach(([key, value]) => {
        if (present.has(key)) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = value;
        input.dataset.lfgProductAttribution = key;
        form.appendChild(input);
      });
    });
  };
  class LfgBackPrint extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.section = this.closest('.shopify-section');
      this.field = this.querySelector('input[name="properties[Back name or class year]"]');
      this.wrapper = this.querySelector('[data-lfg-back-field]');
      try { this.variants = JSON.parse(this.querySelector('[data-lfg-variants]').textContent); }
      catch (_) { this.variants = []; }
      this.refresh = () => {
        const checked = Array.from(this.section.querySelectorAll('variant-picker input[type="radio"]:checked')).map(input => input.value);
        const selected = checked.length ? this.variants.find(variant => variant.options.every((value, index) => checked[index] === value)) : this.variants.find(variant => String(variant.id) === this.form.querySelector('input[name="id"]').value);
        const personalized = !!selected && selected.options.includes('Add name or class year (+$4)');
        this.wrapper.hidden = !personalized;
        this.field.disabled = !personalized;
        this.field.required = personalized;
        const accelerated = this.form.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
        if (accelerated) accelerated.hidden = personalized || !selected?.available;
        if (!personalized) {
          this.field.value = '';
          this.field.setCustomValidity('');
          this.form.querySelectorAll('input[type="hidden"][name="properties[Back name or class year]"]').forEach(input => input.remove());
        }
      };
      this.validate = () => {
        this.field.setCustomValidity(!this.field.disabled && (!this.field.value.trim() || /[\r\n]/.test(this.field.value) || Array.from(this.field.value).length > 20) ? 'Enter one line with 1–20 characters.' : '');
      };
      this.section.addEventListener('change', this.refresh);
      this.field.addEventListener('input', this.validate);
      this.pageShow = () => { this.refresh(); this.validate(); };
      window.addEventListener('pageshow', this.pageShow);
      this.refresh();
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.refresh);
      this.field?.removeEventListener('input', this.validate);
      window.removeEventListener('pageshow', this.pageShow);
    }
  }
  if (!customElements.get('lfg-back-print')) customElements.define('lfg-back-print', LfgBackPrint);
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; applyCampaign(); });
  };
  new MutationObserver(schedule).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  document.addEventListener('visitorConsentCollected', applyCampaign);
  window.addEventListener('pageshow', applyCampaign);
  document.addEventListener('submit', applyCampaign, true);
  applyCampaign();
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) applyCampaign(); });
  }
})();
